export let props = ['list', 'value', 'label', 'name']
export let model = {
  isIndeterminate: false,
  checkAll: true
}
export let computed = {
  checkList: {
    get () {
      return this.value
    },
    set (val) {
      this.$emit('input', val)
    }
  }
}
